<template>
  <div class="box us-box">
    <div class="us-lead">
      <h2>Empleado evaluado</h2>
      <p>
        Aparece solo con el permiso Evaluado. Elige a qué empleado de la empresa
        corresponde este usuario.
      </p>
    </div>

    <div class="us-inline">
      <div class="us-field">
        <label>Buscar empleado</label>
        <b-input
          v-model="search"
          type="search"
          icon="magnify"
          placeholder="Nombre, correo, cargo..."
        ></b-input>
      </div>
      <b-button @click="$emit('load')">Traer empleados</b-button>
    </div>

    <div class="employee-grid">
      <div class="employee-scroll">
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Correo</th>
              <th>Cargo</th>
              <th>Dependencia</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in filtered"
              :key="item._id"
              :class="{ 'is-selected': item._id === selectedId }"
            >
              <td class="employee-name" :title="item.nombre">
                {{ item.nombre }}
              </td>
              <td :title="item.email">{{ item.email }}</td>
              <td :title="item.cargo">{{ item.cargo }}</td>
              <td :title="item.dependencia">{{ item.dependencia }}</td>
              <td class="employee-action">
                <span
                  v-if="item._id === selectedId"
                  class="us-tag us-tag--admin"
                >
                  Seleccionado
                </span>
                <b-button v-else size="is-small" @click="$emit('select', item)">
                  Seleccionar
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-if="!filtered.length" class="employee-empty">{{ emptyText }}</p>
      </div>
      <div class="employee-footer">
        Mostrando {{ filtered.length }} de {{ employees.length }}
        {{ employees.length === 1 ? "empleado" : "empleados" }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmployeePicker",
  props: {
    employees: {
      type: Array,
      required: true,
    },
    selectedId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      search: "",
    };
  },
  computed: {
    filtered() {
      const query = this.search.toLowerCase();
      return this.employees.filter((el) => {
        const text = el.email + el.nombre + el.cargo + el.dependencia + el.proceso;
        return text.toLowerCase().indexOf(query) > -1;
      });
    },
    emptyText() {
      if (!this.employees.length) {
        return "Pulsa «Traer empleados» para cargar la lista";
      }
      return "Ningún empleado coincide con la búsqueda";
    },
  },
};
</script>

<style scoped>
.employee-grid {
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
}

.employee-scroll {
  max-height: 340px;
  overflow: auto;
}

table {
  width: 100%;
  min-width: 620px;
  border-collapse: collapse;
  table-layout: fixed;
}

thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  height: 48px;
  padding: 0 16px;
  border-bottom: 1px solid #e2e2e2;
  background: #fff;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  color: rgba(0, 0, 0, 0.54);
}

thead th:last-child {
  width: 130px;
}

tbody td {
  height: 52px;
  padding: 6px 16px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
  color: #363636;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

tbody tr {
  transition: background-color 0.15s ease;
}

tbody tr:hover,
tbody tr.is-selected {
  background: #f7f4fb;
}

.employee-name {
  font-weight: 600;
}

.employee-action {
  text-align: right;
}

.employee-empty {
  padding: 36px 16px;
  font-size: 14px;
  text-align: center;
  color: #7a7a7a;
}

.employee-footer {
  padding: 10px 16px;
  border-top: 1px solid #f0f0f0;
  font-size: 13px;
  text-align: right;
  color: #7a7a7a;
}
</style>



// WEBPACK FOOTER //
// src/components/users/components/EmployeePicker.vue